import { Helmet } from 'react-helmet-async'
import SEO, { breadcrumbs } from '../components/common/SEO'
import Hero from '../components/sections/Hero'
import Introduction from '../components/sections/Introduction'
import HowWeCare from '../components/sections/HowWeCare'
import Specialties from '../components/sections/Specialties'
import Mission from '../components/sections/Mission'
import GoogleReviews from '../components/sections/GoogleReviews'
import ClinicCarousel from '../components/sections/ClinicCarousel'
import RunClubPromo from '../components/sections/RunClubPromo' // eslint-disable-line no-unused-vars
import Partnerships from '../components/sections/Partnerships'
import { faqsById, faqSchema } from '../data/faqs'
import { optimizedUrl, srcSetFor } from '../utils/images'

const homeFaqs = faqsById(['location', 'services', 'billing', 'hours'])

const HomePage = () => {
  return (
    <>
      <SEO
        title="Massage & Athletic Therapy at Yonge & Eglinton"
        description="Registered massage therapy, athletic therapy, naturopathic care, and acupuncture at Yonge & Eglinton, Midtown Toronto. Book online."
        path="/"
        keywords="massage therapy Toronto, athletic therapy Toronto, RMT Yonge and Eglinton, Midtown Toronto massage, naturopathic medicine Toronto, acupuncture Toronto, TMJ treatment, registered massage therapist"
        structuredData={[breadcrumbs([{ name: 'Home', path: '/' }]), faqSchema(homeFaqs)]}
      />
      <Helmet>
        <link
          rel="preload"
          as="image"
          type="image/avif"
          imagesrcset={srcSetFor('/herov2.jpg', 'avif')}
          imagesizes="100vw"
          media="(min-width: 640px)"
          fetchpriority="high"
        />
        <link
          rel="preload"
          as="image"
          type="image/avif"
          imagesrcset={srcSetFor('/hero_mobile.jpg', 'avif')}
          imagesizes="100vw"
          media="(max-width: 639px)"
          fetchpriority="high"
        />
      </Helmet>
      {/* Single continuous textured background for Hero → Intro → HowWeCare */}
      <div
        className="bg-brand-orange-500 bg-cover bg-center overflow-x-clip touch-pan-y"
        style={{ backgroundImage: `url('${optimizedUrl('/Clay Paper Texture.webp', 1600, 'webp')}')` }}
      >
        <Hero />
        <Introduction />
        <HowWeCare />
      </div>
      <Specialties />
      <ClinicCarousel />
      <Mission />
      <GoogleReviews />
      {/* <RunClubPromo /> — temporarily hidden, restore when ready */}
      <Partnerships />
    </>
  )
}

export default HomePage
